import { Icon, ICONLIB, Icons } from './ICONLIB';

/**
 * Retrieves the SVG content for a given icon name from the ICONLIB.
 * Throws an error if the icon name is not found in the library.
 *
 * @param {string} iconName - The name of the icon to retrieve.
 * @returns {string} The SVG content of the requested icon.
 * @throws {Error} If the specified icon name is not found in the ICONLIB.
 */
export function exportIconFromRegistry(iconName: keyof Icons): Icon {
    const icon: Icon = ICONLIB[iconName];
    if (!icon) {
        throw new Error(`Icon ${iconName} not found`);
    }

    if (icon && 'url' in icon) {
        const iconUrl: string = icon.url;
        if (!iconUrl.startsWith('assets/icons/')) {
            throw new Error(`Icon ${iconName} is not in assets/icons/ folder`);
        }
    }
    return icon;
}
